export default "__VITE_ASSET__Bni2PLvL__"